/**
 * Vocabulário compartilhado das Medidas de Controle Existentes (#221).
 * Mantido em sincronia manual com frontend/src/types/controlMeasures.ts
 * (mesmo padrão de riskMatrix.ts).
 */

export const EXISTING_CONTROL_MEASURE_CATEGORIES = ['ADMINISTRATIVE', 'ENGINEERING'] as const;
export type ExistingControlMeasureCategory = (typeof EXISTING_CONTROL_MEASURE_CATEGORIES)[number];

export const EXISTING_CONTROL_MEASURES: Record<ExistingControlMeasureCategory, readonly string[]> = {
  ADMINISTRATIVE: [
    'Rodízio de trabalhadores',
    'Limitação de tempo de exposição',
    'Programas de conservação',
    'Ficha de Controle de Entrega de EPIs',
    'Treinamentos',
    'Monitoramento médico periódico',
  ],
  ENGINEERING: [
    'Instalação de barreiras acústicas',
    'Isolamento de máquinas',
    'Manutenção preventiva de equipamentos',
  ],
};

export const EXISTING_CONTROL_MEASURE_CATEGORY_LABELS: Record<ExistingControlMeasureCategory, string> = {
  ADMINISTRATIVE: 'Administrativa',
  ENGINEERING: 'Engenharia / EPC',
};
